import { Link } from "react-router-dom";
import { newsItems } from "@/mocks/resources";
import { formatViews, getCategoryMeta, getResourceById } from "@/utils/content";
import SectionHeading from "@/components/base/SectionHeading";

const hotBoard = ["a-01", "mu-02", "a-03", "m-01", "m-08"];

export default function LatestNews() {
  return (
    <section aria-label="最新资讯与热门榜单" className="mt-12 md:mt-16">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-5 md:gap-6">
        <div className="lg:col-span-2 bg-background-50 border border-background-200 rounded-lg p-4 md:p-6">
          <SectionHeading
            title="最新资讯"
            subtitle="按发布时间倒序整理，点击标题可查看对应资源详情"
            icon="ri-newspaper-line"
          />
          <ul className="divide-y divide-background-200">
            {newsItems.map((news, index) => {
              const meta = getCategoryMeta(news.category);
              return (
                <li key={news.id}>
                  <Link
                    to={`/detail/${news.resourceId}`}
                    className="group flex items-start gap-3 py-3 cursor-pointer"
                  >
                    <span className="w-6 shrink-0 text-xs font-heading font-bold text-background-400 mt-0.5">
                      {String(index + 1).padStart(2, "0")}
                    </span>
                    <span className="min-w-0 flex-1">
                      <span className="flex items-center gap-2 flex-wrap mb-1">
                        <span className="chip bg-secondary-100 text-secondary-900">{meta?.label}</span>
                        <span className="text-[11px] text-foreground-400">{news.kind}</span>
                        <span className="text-[11px] text-foreground-400 ml-auto">{news.date}</span>
                      </span>
                      <span className="block text-sm text-foreground-800 leading-6 group-hover:text-primary-600 transition-colors line-clamp-1">
                        {news.title}
                      </span>
                    </span>
                  </Link>
                </li>
              );
            })}
          </ul>
        </div>

        <aside className="h-full flex flex-col bg-primary-950 rounded-lg p-4 md:p-6 text-background-100">
          <div className="flex items-center justify-between mb-4">
            <h2 className="font-heading font-extrabold text-lg text-background-50 flex items-center gap-2">
              <i className="ri-fire-line text-accent-400" aria-hidden="true"></i>
              热门榜单
            </h2>
            <span className="text-[11px] text-background-400">按访问量</span>
          </div>
          <ol className="space-y-3">
            {hotBoard.map((id, index) => {
              const item = getResourceById(id);
              if (!item) return null;
              return (
                <li key={id}>
                  <Link to={`/detail/${id}`} className="group flex items-center gap-3 cursor-pointer">
                    <span
                      className={`w-6 h-6 rounded-md flex items-center justify-center text-xs font-bold shrink-0 ${
                        index < 3 ? "bg-accent-500 text-background-50" : "bg-primary-800 text-background-300"
                      }`}
                    >
                      {index + 1}
                    </span>
                    <span className="min-w-0 flex-1">
                      <span className="block text-sm text-background-100 group-hover:text-accent-300 transition-colors line-clamp-1">
                        {item.title}
                      </span>
                      <span className="block text-[11px] text-background-400 mt-0.5">
                        {item.year} · {item.type} · {formatViews(item.views)}次浏览
                      </span>
                    </span>
                  </Link>
                </li>
              );
            })}
          </ol>

          <div className="mt-auto pt-5">
            <Link
              to="/search"
              className="flex items-center justify-center gap-2 h-10 rounded-md border border-primary-700 text-sm text-background-200 hover:border-accent-400 hover:text-accent-300 cursor-pointer transition-colors"
            >
              <i className="ri-search-line" aria-hidden="true"></i>
              全站资源检索
            </Link>
          </div>
        </aside>
      </div>
    </section>
  );
}